import { DeleteSectionContract } from '@ublend-npm/aula-schema/types/materials';
import { CLASSROOM_MATERIAL_SECTION } from '../../constants/endpoints';
import request from './request';

const deleteSection = async (
  classRoomId: string,
  sectionId: string,
  correlationId?: string,
  educatorOnly?: boolean
) => {
  const url = CLASSROOM_MATERIAL_SECTION(classRoomId, sectionId, educatorOnly);
  const response = await request<DeleteSectionContract>({
    method: 'delete',
    url,
  });
  return response.status === 204;
};

export default deleteSection;
